export { default } from './ProjectSliderControl';
